import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import PageLinkLoader from './components/PageLinkLoader';
import renderBody from '../../components/RichText/RichText';
import { SoftHider } from './FundraiserSignup.style';
import FundraiserSignupContext from './context/FundraiserSignupContext';
import Paragraphs from '../../components/Paragraphs/Paragraphs';

const SuccessSection = ({
  successMessage,
  campaignCode,
  successParagraphs = [],
  userUUID = null,
  showJGPageLinkLoader = true,
  campaignUrl,
  theme,
  partners,
  people,
  articles,
  moneyBuys,
  descriptors
}) => {
  const { isSubmitted } = useContext(FundraiserSignupContext);
  const successSectionRef = useRef(null);

  // Announce success to screen readers and move focus
  useEffect(() => {
    if (isSubmitted && successSectionRef.current) {
      // Move focus to success section for screen readers
      successSectionRef.current.focus();
    }
  }, [isSubmitted]);

  return (
    <SoftHider show={isSubmitted} data-test="section-4">
      <div
        ref={successSectionRef}
        role="status"
        aria-label="Registration successful"
        tabIndex="-1"
      >
        {renderBody(successMessage)}

        { successParagraphs && (
        <Paragraphs
          theme={theme}
          paragraphs={successParagraphs}
          partners={partners}
          people={people}
          articles={articles}
          moneyBuys={moneyBuys}
          descriptors={descriptors}
        />
        )}

        {(isSubmitted && showJGPageLinkLoader) && (
          <PageLinkLoader
            UUID={userUUID}
            campaignCode={campaignCode}
            campaignUrl={campaignUrl}
          />
        )}
      </div>
    </SoftHider>
  );
};

SuccessSection.propTypes = {
  successMessage: PropTypes.shape({ raw: PropTypes.string.isRequired })
    .isRequired,
  // eslint-disable-next-line
  successParagraphs: PropTypes.arrayOf(PropTypes.object),
  userUUID: PropTypes.string,
  showJGPageLinkLoader: PropTypes.bool,
  campaignCode: PropTypes.string.isRequired,
  campaignUrl: PropTypes.string,
  theme: PropTypes.string,
  partners: PropTypes.arrayOf(PropTypes.shape),
  people: PropTypes.arrayOf(PropTypes.shape),
  articles: PropTypes.arrayOf(PropTypes.shape),
  moneyBuys: PropTypes.arrayOf(PropTypes.shape),
  descriptors: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape),
    group: PropTypes.arrayOf(PropTypes.shape)
  })
};

export default SuccessSection;
